import { TxRecord } from './tx.record'
import { RECORDS_VERBOSE, DIRECTION_VERBOSE } from './help/records.const'
import get from 'lodash/get'

export class InvoiceAssetHistoryRecord extends TxRecord {
  constructor (record) {
    super(record, RECORDS_VERBOSE.invoice)

    this.amount = record.amount
    this.asset = record.asset
    this.sender = record.sender
    this.counterparty = get(record, 'source_account')
    this.invoiceNumber = get(record, 'invoice_number')
  }

  get direction () { return this._getDirection() }
  _getDirection () {
    return DIRECTION_VERBOSE.out
  }
}



// WEBPACK FOOTER //
// ./src/js/records/invoice_asset_history.record.js